module.exports = __webpack_public_path__ + "static/media/The_miller_delivering_flour_to_people_homes.3034647c.jpg";